import { render, staticRenderFns } from "./layoutFooter.vue?vue&type=template&id=5da9bba6&scoped=true&"
import script from "./layoutFooter.vue?vue&type=script&lang=js&"
export * from "./layoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./layoutFooter.vue?vue&type=style&index=0&id=5da9bba6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9bba6",
  null
  
)

export default component.exports